import React from "react";
import "../../Styles/yellowcalf.css/Wallet_sale.css";
import userImg from "../../images/user.png";
import { Link } from "react-router-dom";

function Wallet_sale() {
  return (
    <div className="wallet-main-content" style={{ paddingTop: "25px" }}>
      <div className="wallet-main-container">

        <div className="wallet-main-panel wallet-main-page-header" style={{height:'64px'}}>
          <div className="wallet-main-panel-body">
            <div className="wallet-main-customer-index">
              <h3 className="wallet-main-title">Wallet Sales</h3>
              <div className="wallet-main-btn-group">
                <button
                  className="wallet-main-btn-warning dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Export <i className="fa fa-angle-down"></i>
                </button>
                <ul className="wallet-main-dropdown dropdown-menu dropdown-menu-end">
                  <li>
                    <a className="wallet-main-item" href="#">
                      Save as PDF
                    </a>
                  </li>
                  <li>
                    <a className="wallet-main-item" href="#">
                      Save as PNG
                    </a>
                  </li>
                  <li>
                    <a className="wallet-main-item" href="#">
                      Save as CSV
                    </a>
                  </li>
                  <li>
                    <a className="wallet-main-item" href="#">
                      Save as TXT
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="wallet-main-panel" >
          <div className="wallet-main-panel-body">
            <div className="wallet-main-table-wrapper" >
              <table className="wallet-main-table"  style={{marginTop:'-12px'}}>
              <thead style={{ height: '70px' }}>

                  <tr>
                    <th style={{ textAlign: "center" }}>Sr.No</th> 
                    <th style={{ textAlign: "center" }}>Image</th>
                    <th style={{ textAlign: "center" }}>Student</th>
                    <th style={{ textAlign: "center" }}>Amount</th>
                    <th style={{ textAlign: "center" }}>Description</th>
                    <th style={{ textAlign: "center" }}>Date Time</th>
                    <th style={{ textAlign: "center" }}>Action</th> 
                  </tr>
                </thead>
                    <tbody> 
                  {[1, 2, 3, 4, 5].map((i) => (
                    <tr key={i} >
                      <td style={{ textAlign: "center" , fontSize:'13px'}}>{i}</td>
                      <td style={{ textAlign: "center" , fontSize:'13px'}}>
                        <img
                          src={userImg}
                          width="35"
                          height="35"
                          alt="User"
                          className="wallet-main-img"
                        />
                      </td>
                      <td style={{ textAlign: "center", fontSize:'13px' }}>Mayank</td>
                      <td style={{ textAlign: "center", fontSize:'13px' }}>$ 500</td>
                      <td style={{ textAlign: "center" , fontSize:'13px'}}>Balance adjusted to invoice payment</td>
                      <td style={{ textAlign: "center" , fontSize:'13px'}}>Wed Sep 25 2024 10:50:54 AM</td>
                      <td style={{ textAlign: "center" , fontSize:'13px' }}>
                        <Link
                          to="/walletreceipt"
                          className="wallet-main-btn-green"
                          title="view"
                        >
                          <i className="bi bi-eye"></i>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
       <div className="wallet-main-footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '12px', padding: '0 24px' }}>
  
  <div
    className="wallet-main-summary"
    style={{
      marginLeft:'-1080px',
      fontSize: '14px',
      color: '#666',
    }}
  >
    Showing <b>1-6</b> of <b>6</b> items.
  </div>

  <ul className="wallet-main-pagination" style={{ display: 'flex', listStyle: 'none', gap: '8px', marginLeft: '1099px', padding: 0 , marginTop:'-30px' }}>
    <li className="wallet-main-active">
      <a href="#">1</a>
    </li>
    <li>
      <a href="#">2</a>
    </li>
    <li>
      <a href="#">3</a>
    </li>
  </ul>

</div>


         
            </div>
          </div>
        </div>
      </div>
  
  );
}

export default Wallet_sale;
